// various settings for the report
var chartSettings = {
  "progress_circle": {
    "fill": "rgb(168, 220, 182)",
    "thickness": 9
  },
  "chartjs": {
    "datalabels": {
      "display": false
    }
  },
  "image_path": "/static/images/"
};

export default chartSettings;



// WEBPACK FOOTER //
// ./src/modules/chartSettings.js